{
  "name": "@hoppscotch/cli",
  "version": "0.31.1",
  "description": "A CLI to run Hoppscotch test scripts in CI environments.",
  "homepage": "https://hoppscotch.io",
  "type": "module",
  "main": "dist/index.js",
  "bin": {
    "hopp": "bin/hopp.js"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=22"
  },
  "scripts": {
    "build": "pnpm exec tsup",
    "dev": "pnpm exec tsup --watch",
    "debugger": "node debugger.js 9999",
    "prepublish": "pnpm exec tsup",
    "prettier-format": "prettier --config .prettierrc 'src/**/*.ts' --write",
    "test": "pnpm run build && vitest run",
    "do-typecheck": "pnpm exec tsc --noEmit",
    "do-test": "pnpm run test"
  },
  "keywords": [
    "cli",
    "hoppscotch",
    "hopp-cli"
  ],
  "author": "Hoppscotch (support@hoppscotch.io)",
  "repository": {
    "type": "git",
    "url": "https://github.com/hoppscotch/hoppscotch.git"
  },
  "bugs": {
    "url": "https://github.com/hoppscotch/hoppscotch/issues",
    "email": "support@hoppscotch.io"
  },
  "license": "MIT",
  "private": false,
  "dependencies": {
    "aws4fetch": "1.0.20",
    "axios": "1.15.2",
    "axios-cookiejar-support": "6.0.5",
    "chalk": "5.6.2",
    "commander": "14.0.3",
    "isolated-vm": "6.1.2",
    "js-md5": "0.8.3",
    "jsonc-parser": "3.3.1",
    "lodash-es": "4.18.1",
    "papaparse": "5.5.3",
    "qs": "6.15.1",
    "semver": "7.7.4",
    "tough-cookie": "6.0.1",
    "verzod": "0.4.0",
    "xmlbuilder2": "4.0.3",
    "zod": "3.25.32"
  },
  "devDependencies": {
    "@hoppscotch/data": "workspace:^",
    "@hoppscotch/js-sandbox": "workspace:^",
    "@relmify/jest-fp-ts": "2.1.1",
    "@types/lodash-es": "4.17.12",
    "@types/papaparse": "5.5.2",
    "@types/qs": "6.15.0",
    "fp-ts": "2.16.11",
    "prettier": "3.8.3",
    "tsup": "8.5.1",
    "typescript": "5.9.3",
    "vitest": "4.1.5"
  }
}
